import { useRef } from 'react';
import { Grid, Header, Icon, Image, Item, Segment } from 'semantic-ui-react';
import WikiNav from '../WikiNav';
import { WikiSearchProvider } from '../WikiSearchContext';
import useHighlightMatches from '../useHighlightMatches';

const sessionImageStyle = {
  filter: 'brightness(100%)',
};

const sessionImageTextStyle = {
  position: 'absolute',
  bottom: '5%',
  left: '1%',
  width: '100%',
  height: 'auto',
  color: 'white',
};

const WikiPageContent = () => {
  const contentRef = useRef(null);
  useHighlightMatches(contentRef);

  return (
    <Grid id="detailed-segment">
      <Grid.Column width={16}>
        <Segment.Group>
          <Segment basic attached="top" style={{ padding: '0' }} id="segment">
            <Image
              src={`/assets/categoryImages/PinkHeader.svg`}
              id="header-image"
              fluid
              style={sessionImageStyle}
            />

            <Segment basic style={sessionImageTextStyle}>
              <Item.Group>
                <Item>
                  <Item.Content>
                    <Header size="huge" id="wiki-header">
                      Wiki
                    </Header>
                  </Item.Content>
                </Item>
              </Item.Group>
            </Segment>
          </Segment>

          <Segment id="segment">
            <WikiNav />

            <div ref={contentRef}>
              <Grid verticalAlign="middle">
                <Grid.Column width={16} id="dg">
                  <p id="orange">
                    This wiki/handbook is an abbreviated encapsulation of our
                    guiding principles. As React continues to grow, we hope that
                    these principles will serve each new person joining our
                    team. If you are new to React, welcome. Although the goals
                    in this book are important, it's really your ideas, talent,
                    and energy that will keep React shining in the years ahead.
                  </p>
                </Grid.Column>
              </Grid>
            </div>
            <br />
          </Segment>
          <Segment id="segment">
            <p id="green">
              <Icon name="mail outline" />
              <a href="mailto:info@reactbh.org?subject=Portal">
                Email Us - tech support, suggestions, etc.
              </a>
            </p>
          </Segment>
        </Segment.Group>
      </Grid.Column>
    </Grid>
  );
};

const WikiPage = () => (
  <WikiSearchProvider>
    <WikiPageContent />
  </WikiSearchProvider>
);

export default WikiPage;
